import React, {useState, useRef, useContext} from 'react';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import {MDBCheckbox} from 'mdb-react-ui-kit';
import {useNavigate} from 'react-router';
import {useParams} from 'react-router-dom';
import {updatePhotoExtra} from '../../../services/MadricService';
import {MadricContext} from '../../../Context/MadricContext';


/**
 * Vue d'une photo
 * @param {*} props props
 * @return {JSX}
 */
function PhotoList(props) {
  let returnTo = 'pasHistorique';
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const {projectInfo, setProjectInfo} = useContext(MadricContext);

  const extra = useRef({
    extra1: props.photo.extra1,
    extra2: props.photo.extra2,
    extra3: props.photo.extra3,
    avancement: props.photo.avancement,
  });

  const navigate = useNavigate();
  const {id} = useParams();

  const handlePhotoClick = (photo) => {
    document.body.classList.add('modal-open');
    setSelectedPhoto(photo);
  };

  const handleCloseModal = () => {
    document.body.classList.remove('modal-open');
    setSelectedPhoto(null);
  };

  const handleZoom = (event) => {
    const img = event.target;
    const currentScale = parseFloat(img.style.transform.replace('scale(', '').replace(')', '') || 1);
    const delta = event.deltaY > 0 ? -0.1 : 0.1;
    const newScale = Math.max(currentScale + delta, 0.1);
    img.style.transform = `scale(${newScale})`;
  };

  const handleModalScroll = (event) => {
    event.preventDefault();
  };
  /**
 * Permet de modifier les extras
 * @param {*} event event
 */
  async function handleChangeExtra(event) {
    extra.current = {
      ...extra.current,
      [event.target.name]: event.target.checked,
    };


    const updatedPhoto = projectInfo.map((p) => {
      if (p.id === props.photo.id && (p.type === 'photo' || p.type === 'facture')) {
        return {
          ...p,
          extra1: extra.current.extra1,
          extra2: extra.current.extra2,
          extra3: extra.current.extra3,
          avancement: extra.current.avancement,

        };
      }
      return p;
    });
    setProjectInfo(updatedPhoto);
    await updatePhotoExtra(props.photo.id, extra.current);
  }


  return (
    <div key={props.photo.id} className="chantierheure-photo-card">
      {localStorage.getItem('admin') === '1' || props.photo.user_id === parseInt(localStorage.getItem('id')) ?
      <div style={{margin: '6px', cursor: 'pointer'}}>
        <FontAwesomeIcon
          icon={faPencilAlt}
          onClick={() => {
            const photo = props.photo;
            const isFacture = props.isFacture;
            navigate('/UpdatePhoto', {state: {photo, id, isFacture, returnTo}});
          }
          } />
      </div> : '' }
      <LazyLoadImage
        src={props.photo.url}
        alt={props.photo.title}
        className="chantierheure-photo"
        placeholderSrc="/images/notloaded.png"
        onClick={() => handlePhotoClick(props.photo)}
        effect="blur" />
      <div className="chantierheure-photo-info">
        <p className="chantierheure-photo-description">
          {props.photo.user_name}
        </p>
        <p className="chantierheure-photo-description">
          {props.photo.date}
        </p>
        <p className="chantierheure-photo-description">
          {props.photo.facturename == null ? '' : 'Facture: ' + props.photo.facturename}
        </p>
        <p className="chantierheure-photo-description">
          {props.photo.montant == null ? '' : 'Montant ' + props.photo.montant + '$'}
        </p>

        <MDBCheckbox name='extra1' id='inlineCheckbox1a' onChange={handleChangeExtra} defaultChecked={props.photo.extra1} inline label='Extra possible' />
        {localStorage.getItem('admin') === '1' ?
              <React.Fragment>
                <MDBCheckbox name='extra2' id='inlineCheckbox2a' onChange={handleChangeExtra} defaultChecked={props.photo.extra2} inline label='Extra validé' />
                <MDBCheckbox name='extra3' id='inlineCheckbox3a' onChange={handleChangeExtra} defaultChecked={props.photo.extra3} inline label='Extra confirmé' />

              </React.Fragment> : '' }
        <MDBCheckbox name='avancement' id='inlineCheckbox4a' onChange={handleChangeExtra} defaultChecked={props.photo.avancement} inline label='Avancement' />

        <p className="chantierheure-photo-description" style={{paddingRight: '12px', paddingLeft: '12px'}}>
          {props.photo.note}
        </p>
      </div>
      {selectedPhoto && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <img
            src={selectedPhoto.url}
            alt={selectedPhoto.title}
            className="modal-photo"
            onWheel={handleZoom}
            onTouchMove={handleModalScroll} />
        </div>)}
    </div>
  );
}

export default PhotoList;
